import { mdlAgencyHotelMarketPair } from "../models/domain/AgecyHotelMarketPair";
import { mdlAgencyMarketPairListRequest } from "../models/service-models/agency-market/AgencyMarketPairListRequest";
import { mdlBaseDataResponse } from "../models/service-models/common/BaseDataResponse";
import { mdlBaseOperationResponse } from "../models/service-models/common/BaseOperationResponse";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlMarketCopyToOtherHotelsRequest } from "../models/service-models/market/MarketCopyToOtherHotelsRequest";
import { mdlMarketCreateRequest } from "../models/service-models/market/MarketCreateRequest";
import { mdlMarketCreateResponse } from "../models/service-models/market/MarketCreateResponse";
import { mdlMarketDeleteRequest } from "../models/service-models/market/MarketDeleteRequest";
import { mdlMarketDeleteResponse } from "../models/service-models/market/MarketDeleteResponse";
import { mdlMarketDetailRequest } from "../models/service-models/market/MarketDetailRequest";
import { mdlMarketDetailResponse } from "../models/service-models/market/MarketDetailResponse";
import { mdlMarketListRequest } from "../models/service-models/market/MarketListRequest";
import { mdlMarketListResponse } from "../models/service-models/market/MarketListResponse";
import { mdlMarketUpdateRequest } from "../models/service-models/market/MarketUpdateRequest";
import { mdlMarketUpdateResponse } from "../models/service-models/market/MarketUpdateResponse";
import { mdlSystemMarketListRequest } from "../models/service-models/market/SystemMarketListRequest";
import { mdlSystemMarketListResponse } from "../models/service-models/market/SystemMarketListResponse";
import { GetResponse } from "../utils/ApiClient";

namespace MarketService {
    export async function Create(
        pRequest: mdlMarketCreateRequest
    ): Promise<mdlServiceResponse<mdlMarketCreateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlMarketCreateResponse>>(
            "market/create",
            pRequest
        );
    }

    export async function Update(
        pRequest: mdlMarketUpdateRequest
    ): Promise<mdlServiceResponse<mdlMarketUpdateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlMarketUpdateResponse>>(
            "market/update",
            pRequest
        );
    }

    export async function Copy(
        pRequest: mdlMarketCopyToOtherHotelsRequest
    ): Promise<mdlServiceResponse<mdlBaseOperationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlBaseOperationResponse>>(
            "market/copy",
            pRequest
        );
    }

    export async function Delete(
        pRequest: mdlMarketDeleteRequest
    ): Promise<mdlServiceResponse<mdlMarketDeleteResponse>> {
        return await GetResponse<mdlServiceResponse<mdlMarketDeleteResponse>>(
            "market/delete",
            pRequest
        );
    }

    export async function List(
        pRequest: mdlMarketListRequest
    ): Promise<mdlServiceResponse<mdlMarketListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlMarketListResponse>>(
            "market/list",
            pRequest
        );
    }

    export async function Detail(
        pRequest: mdlMarketDetailRequest
    ): Promise<mdlServiceResponse<mdlMarketDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlMarketDetailResponse>>(
            "market/detail",
            pRequest
        );
    }
    export async function SystemMarketList(
        pRequest: mdlSystemMarketListRequest
    ): Promise<mdlServiceResponse<mdlSystemMarketListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlSystemMarketListResponse>>(
            "market/system-market-list",
            pRequest
        );
    }

    export async function AgencyMarketPairList(
        pRequest: mdlAgencyMarketPairListRequest
    ): Promise<mdlServiceResponse<mdlBaseDataResponse<Array<mdlAgencyHotelMarketPair>>>> {
        return await GetResponse<mdlServiceResponse<mdlBaseDataResponse<Array<mdlAgencyHotelMarketPair>>>>(
            "market/get-all-agency-markets",
            pRequest
        );
    }



}
export { MarketService };
